module.exports = __webpack_public_path__ + "img/no-data-bitda.b8caaf82.png";